<template>
  <div class="cp-card">
    <div class="cp-card-left">
      <cp-results :id="id" :state="state" :controller="controller" />
    </div>
    <div class="cp-card-right" v-if="id && sourceId">
      <cp-files :id="id" :source-id="sourceId" />
      <cp-comments :id="id" :source-id="sourceId" />
    </div>
  </div>
</template>

<script>
import CpResults from "./cp-results";
import CpFiles from "./cp-files";
import CpComments from "./cp-comments";

export default {
  props: ["state", "controller"],
  components: {
    CpResults,
    CpFiles,
    CpComments
  },
  computed: {
    id() {
      return this.$store.state.trafficCount.fill.activeCp;
    },
    sourceId() {
      return this.$store.state.trafficCount.model.ids["count_points"];
    }
  }
};
</script>

<style lang="scss">
.cp-card {
  max-height: 480px;
  display: flex;

  &-left {
    width: 50%;
    border-right: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;
  }
  &-right {
    width: 50%;
    display: flex;
  }
}
</style>
